import { render, staticRenderFns } from "./FMiniForm.vue?vue&type=template&id=1a2678ba&"
import script from "./FMiniForm.vue?vue&type=script&lang=ts&"
export * from "./FMiniForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports